import React from 'react';
import { Breadcrumb, Panel } from 'rsuite';
import CountryList from './country-list';
import PageHeader from '@/components/PageHeader';

const Page = () => {
  return (
    <Panel
      header={
        <PageHeader title="Countries">
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item >Master Data</Breadcrumb.Item>
            <Breadcrumb.Item active>Countries</Breadcrumb.Item>
          </Breadcrumb>
        </PageHeader>
      }
    >
      <CountryList />
    </Panel>
  );
};

export default Page;
